import { createApi } from "@reduxjs/toolkit/query/react";
import fetchFromWordpressApi from "./../utils/api/fetchFromWordpressApi";

export const themeApi = createApi({
    reducerPath: "themeApi",
    baseQuery: async ({ endpoint, params }) => {
        try {
            const data = await fetchFromWordpressApi(endpoint, params);
            return { data };
        } catch (error) {
            return { error: { message: error.message } };
        }
    },
    endpoints: (builder) => ({
        getMenu: builder.query({
            query: (menuId) => ({ endpoint: `menus/${menuId}` }),
        }),
        getThemeOptions: builder.query({
            query: () => ({ endpoint: "acf-options/theme-options" }),
        }),
        getRealizationsOptions: builder.query({
            query: () => ({ endpoint: "acf-options/realization-options" }),
        }),
        getPosts: builder.query({
            query: ({ postType, perPage, page, taxonomy }) => ({
                endpoint: "posts",
                params: { post_type: postType, per_page: perPage, page, taxonomy },
            }),
        }),
    }),
});

export const { useGetMenuQuery, useGetThemeOptionsQuery, useGetPostsQuery } = themeApi;
